import React, { Component } from "react";

import PortalView from "features/new/portal/view";

class Portal extends Component {
  componentDidMount() {
    this.animateSlideIn();

    window.addEventListener("resize", () => this.animateSlideIn());
    window.addEventListener("scroll", () => this.animateSlideIn());
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => this.animateSlideIn());
    window.removeEventListener("scroll", () => this.animateSlideIn());
  }

  animateSlideIn() {
    let elements = document.getElementsByClassName(
      "portal__animation--slide-in"
    );

    for (let i = 0; i < elements.length; i++) {
      let difference =
        0 - (elements[i].getBoundingClientRect().top - window.innerHeight);

      difference <= 0 && (elements[i].style.transform = "translateY(200px)");

      difference > 0 &&
        difference < 400 &&
        (elements[i].style.transform = `translateY(${200 - difference / 2}px)`);

      difference >= 400 && (elements[i].style.transform = "translateY(0)");
    }
  }

  render() {
    return <PortalView />;
  }
}

export default Portal;
